<template>
    <div>
        <div class="flex justify-end">
            <div class="flex items-stretch space-x-4">
                <div><img :src="avatar" class="w-[42px] h-[42px] rounded-full"></div>
                <div class="flex items-center text-[#C4C4C4]">|</div>
                <div class="relative flex items-center" ref="accountDropdown">
                    <a href="#" @click.prevent="isDropdown = !isDropdown" class="inline-flex items-center space-x-2 text-sm font-medium">
                        <span>Account Settings</span>
                        <svg width="12" height="9" :class="{'rotate-180': isDropdown}" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 0L11.1962 9L0.803848 9L6 0Z" fill="#00F4C8"/></svg>
                    </a>

                    <div v-show="isDropdown" class="absolute top-full right-0 text-white text-sm w-[200px] py-2 rounded-md bg-secondary">
                        <a href="#" @click.prevent="showAccount = !showAccount; isDropdown = false" class="flex items-center px-4 py-2 hover:bg-teal">
                            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                            <span>Change Password</span>
                        </a>

                        <a :href="route('logout')" class="flex items-center px-4 py-2 hover:bg-teal">
                            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
                            <span>Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showAccount">
            <div class="pb-10 mb-12 border-b border-gray-200">
                <h2 class="mb-2 text-2xl font-bold text-left text-black no-underline normal-case non-italic">Account Settings</h2>
                <p class="text-lg font-normal text-left no-underline normal-case non-italic">You can edit your personal account details here.</p>
            </div>

            <div class="flex items-center justify-between space-x-4 mb-7">
                <h3 class="text-lg font-bold text-black">Account Details</h3>
                <a href="#" @click.prevent="accountEdit = !accountEdit" class="text-black"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path></svg></a>
            </div>

            <app-errors :form="accountForm" class="mb-10"></app-errors>

            <div v-if="accountForm.successful" class="mb-10">
                <div class="p-4 rounded-md bg-green-50">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <svg class="w-5 h-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" /></svg>
                        </div>
                        <div class="ml-3">
                            <p class="text-sm font-medium text-green-800">
                                Successfully updated
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!accountEdit" class="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-8">
                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Email Address</h4>
                    <div class="py-1 mt-1 text-lg">{{ accountForm.email }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Password</h4>
                    <div class="py-1 mt-1 text-lg">••••••••••••••••</div>
                </div>
            </div>
            <div v-else class="grid grid-cols-1 sm:grid-cols-3 gap-x-12 gap-y-8">
                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Email Address</h4>
                    <div class="py-1 mt-1 text-lg"><text-field v-model="accountForm.email" :required="true"></text-field></div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">New Password</h4>
                    <div class="py-1 mt-1 text-lg"><text-field type="password" v-model="accountForm.password" :required="true"></text-field></div>
                    <p class="mt-1 text-xs opacity-70">Keep this blank if you don't want to change your password.</p>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Confirm Password</h4>
                    <div class="py-1 mt-1 text-lg"><text-field type="password" v-model="accountForm.password_confirmation" :required="true"></text-field></div>
                </div>
            </div>
        </div>

        <div v-else>
            <div class="pb-10 mb-12 border-b border-gray-200">
                <h2 class="mb-2 text-2xl font-bold text-left text-black no-underline normal-case non-italic">Summary</h2>
                <div class="flex items-center mb-4 space-x-2 text-sm font-bold">
                    <svg class="w-4 h-4 text-teal" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                    <span>Mammoth is reviewing your details and will be in touch with any of your questions.</span>
                </div>
                <p class="mb-4 text-lg font-normal text-left no-underline normal-case non-italic">This the summary of your <span class="font-bold text-teal">investment</span> be sure to verify all details included.</p>
                <p class="text-lg font-normal text-left no-underline normal-case non-italic">Please contact <a href="mailto:hello@mammothresearch.com" class="font-bold text-black no-underline">hello@mammothresearch.com</a> if there are any changes required.</p>
            </div>

            <app-errors :form="storeForm" class="mb-10"></app-errors>

            <div class="flex items-center justify-between space-x-4 mb-7">
                <h3 class="text-lg font-bold text-black">Account Details</h3>
            </div>

            <div class="grid grid-cols-1 mb-8 sm:grid-cols-2 gap-x-12 gap-y-8">
                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Account Name</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.accountName }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Offering Name</h4>
                    <div class="py-1 mt-1 text-lg">Mammoth Research, LLC</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Email Address</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.emailAddress }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Total Amount</h4>
                    <div class="py-1 mt-1 text-lg" v-currency="{prefix: '$'}">{{ summaryData.totalAmount }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Phone Number</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.phoneNumber }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Total Shares</h4>
                    <div class="py-1 mt-1 text-lg">1</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Address</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.address }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Payment Method</h4>
                    <div class="py-1 mt-1 text-lg">
                        <span v-if="onboardingData.investData.fund.which == 'ach'">ACH</span>
                        <span v-if="onboardingData.investData.fund.which == 'wire'">Wire</span>
                        <span v-if="onboardingData.investData.fund.which == 'ira'">IRA</span>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-between space-x-4 mb-7">
                <h3 class="text-lg font-bold text-black">Investment Details</h3>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-8">
                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Investment</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.investmentName }} - {{ summaryData.investmentType }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Total Amount</h4>
                    <div class="py-1 mt-1 text-lg">{{ summaryData.totalAmount }}</div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Transaction Type</h4>
                    <div class="py-1 mt-1 text-lg capitalize">
                        <span v-if="onboardingData.investData.fund.which == 'ach'">ACH</span>
                        <span v-if="onboardingData.investData.fund.which == 'wire'">Wire</span>
                        <span v-if="onboardingData.investData.fund.which == 'ira'">IRA</span>
                    </div>
                </div>

                <div class="col-span-1">
                    <h4 class="block text-base font-medium text-gray-500">Purchase Date</h4>
                    <div class="py-1 mt-1 text-lg">{{ currentDate }}</div>
                </div>
            </div>
        </div>

        <div class="mt-20 sm:flex sm:justify-end">
            <div class="inline-flex items-center space-x-3">
                <app-button v-if="showAccount" @click="handleBack" class="!border-gray-200 !bg-white !text-gray-400">Back</app-button>

                <app-button v-if="!showAccount" @click="handleNext" :busy="isBusy">
                    Confirm Details
                </app-button>

                <app-button v-else @click="handleUpdateAccount" :busy="isBusy">
                    Save Changes
                </app-button>
            </div>
        </div>
    </div>

    <app-modal :show="success" class="sm:!max-w-[820px]">
        <div class="p-12 bg-white bg-top bg-no-repeat bg-contain rounded-md md:py-24" style="background-image: url(img/congrats-bg.png)">
            <div class="w-full mx-auto md:max-w-lg">
                <div class="w-full mx-auto print:hidden sm:w-[240px]"><img :src="asset('img/pulse-check.png')" class="block w-full h-auto" alt="congrats"></div>

                <h2 class="mb-1 -mt-6 text-2xl font-bold text-center">Congratulations!</h2>
                <p class="mb-8 text-sm font-medium text-center">You are an official investor in {{ summaryData.investmentName }}. Thank you for taking the time to Invest Beyond the Ordinary™ with Mammoth.</p>
                <p class="mb-4 text-xs print:hidden">How would you like to receive future communications from Mammoth Research? You may also select both.</p>
                <div class="flex flex-col mb-8 space-x-0 space-y-4 print:hidden sm:flex-row sm:space-x-8 sm:space-y-0 sm:items-center">
                    <div class="flex items-center">
                        <input v-model="form.service" type="checkbox" id="notify-email" class="w-4 h-4 border-gray-300 rounded focus:ring-teal text-teal" value="email">
                        <label for="notify-email" class="block ml-3 text-xs font-medium text-gray-700">
                            Email ({{ summaryData.emailAddress }})
                        </label>
                    </div>

                    <div class="flex items-center">
                        <input v-model="form.service" type="checkbox" id="notify-text" class="w-4 h-4 border-gray-300 rounded focus:ring-teal text-teal" value="phone">
                        <label for="notify-text" class="block ml-3 text-xs font-medium text-gray-700">
                            Text Message {{ summaryData.phoneNumber }}
                        </label>
                    </div>
                </div>
                <p class="mb-2 text-xs">If you selected ACH, your money will move without further action.</p>
                <p class="mb-2 text-xs">If you selected WIRE TRANSFER, you will need to do the following:</p>
                <div class="p-6 text-gray-400 rounded-md bg-gray-50">
                    <p class="mb-2 text-xs">Contact your bank to send your funds to:</p>
                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
                        <div class="col-span-1 space-y-4 text-sm font-medium">
                            <div>
                                <h3 class="block mb-2 text-gray-600">Wire To</h3>
                                <div>TRISTATE CAPITAL BANK</div>
                                <div>ONE OXFORD CENTRE, SUITE 2700</div>
                                <div>301 GRANT STREET</div>
                                <div>PITTSBURGH, PA 15219</div>
                            </div>

                            <div>
                                <h3 class="block mb-2 text-gray-600">FFCT:</h3>
                                <div>OFFERING NAME AND INVESTOR NAME</div>
                            </div>

                            <div>
                                <h3 class="block mb-2 text-gray-600">Swift ID</h3>
                                <div>TRTTUS33</div>
                            </div>
                        </div>

                        <div class="col-span-1 space-y-4 text-sm font-medium">
                            <div>
                                <h3 class="block mb-2 text-gray-600">Custodian / Account Name</h3>
                                <div>TRISTATE CAPITAL BANK</div>
                                <div>ONE OXFORD CENTRE, SUITE 2700</div>
                                <div>301 GRANT STREET</div>
                                <div>PITTSBURGH, PA 15219</div>
                            </div>

                            <div>
                                <h3 class="block mb-2 text-gray-600">ABA (Routing Number)</h3>
                                <div>043019 0 03</div>
                            </div>

                            <div>
                                <h3 class="block mb-2 text-gray-600">Account Number</h3>
                                <div>0220003339</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center justify-end mt-3 print:hidden">
                        <a href="#" @click.prevent="handlePrint"><svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clip-rule="evenodd"></path></svg></a>
                    </div>
                </div>
                <p class="mt-8 text-xs text-gray-400">Any questions? We are happy to help whenever you need us. Please reach out to <a href="mailto:hello@mammothresearch.com" class="text-black">hello@mammothresearch.com</a> if you need assistance.</p>
                <p class="mt-2 text-xs font-medium text-right">- The Mammoth Team</p>
            </div>

            <div class="flex items-center justify-end mt-12 print:hidden">
                <app-button @click="handleDone" :busy="isBusy" class="!px-8">Done</app-button>
            </div>
        </div>
    </app-modal>
</template>

<script>
import AppButton from '@Components/Button'
import AppModal from '@Components/Modal'
import AppErrors from '@Components/Errors.vue'
import AppDropdown from '@Components/Dropdown.vue'
import CheckboxField from '@Fields/Checkbox'
import TextField from '@Fields/Text.vue'
import useForm from '@/form'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppButton,
        AppModal,
        AppErrors,
        AppDropdown,
        CheckboxField,
        TextField
    },
    props: ['series'],
    emits: ['goto', 'prev', 'next', 'process', 'complete'],
    setup(props, { emit }){
        const pageData = usePage().props.value

        const isBusy = ref(false)

        const success = ref(false)

        const isDropdown = ref(false)

        const showAccount = ref(false)

        const accountDropdown = ref(null)

        const accountEdit = ref(false)

        const store = useStore()

        const form = useForm({
            service: []
        })

        const storeForm = useForm({
            intake: '',
            step: 5,
            series: props.series
        })

        const accountForm = useForm({
            email: _.get(pageData, 'auth.user.email', ''),
            password: '',
            password_confirmation: ''
        })

        onClickOutside(accountDropdown, (event) => {
            isDropdown.value = false
            console.log(event)
        })

        const onboardingData = computed(() => {
            return {
                investingType: store.state.profileForm.investingType,
                subInvestingType: store.state.profileForm.subInvestingType,
                primaryData: store.state.profileForm.primary,
                secondaryData: store.state.profileForm.secondary,
                entityData: store.state.profileForm.entity,
                iraData: store.state.profileForm.ira,
                suitabilityData: store.state.suitabilityForm,
                investData: store.state.investForm,
            }
        })

        const summaryData = computed(() => {
            const investingType    = onboardingData.value.investingType
            const firstName        = _.get(onboardingData.value.primaryData, 'firstName', '')
            const lastName         = _.get(onboardingData.value.primaryData, 'lastName', '')
            const partnerFirstName = _.get(onboardingData.value.secondaryData, 'firstName', '')
            const partnerLastName  = _.get(onboardingData.value.secondaryData, 'lastName', '')
            const entityName       = _.get(onboardingData.value.entityData, 'entityName', '')
            const phoneNumber      = _.get(onboardingData.value.primaryData, 'mobilePhone', _.get(onboardingData.value.primaryData, 'phone', ''))
            const emailAddress     = _.get(onboardingData.value.primaryData, 'email', '')
            const address          = _.get(onboardingData.value.primaryData, 'address1', '')
            const fullName         = firstName + ' ' + lastName
            const netWorth         = _.get(onboardingData.value.suitabilityData, 'netWorth')
            const seriesType       = _.get(pageData, 'auth.user.series_type', 'default')

            return {
                accountName: (investingType == 'entity') ? entityName : (investingType == 'joint' ? `${firstName} ${lastName} & ${partnerFirstName} ${partnerLastName}` : fullName),
                offeringName: 'Mammoth Research, LLC',
                emailAddress: emailAddress,
                phoneNumber: phoneNumber,
                address: address,
                totalAmount: _.get(onboardingData.value.investData, 'amount', ''),
                fullName: fullName,
                investmentType: (netWorth == '5m_plus') ? 'Qualified' : 'Accredited',
                investmentName: (seriesType == 'nsight') ? 'Mammoth Private Capital, LLC-Health and Tech Fund Series 4' : 'Mammoth Health and Tech Fund 1'
            }
        })

        function handleEdit(step){
            emit('goto', step)
        }

        function handleBack(){
            accountEdit.value = false
            showAccount.value = false
        }

        async function handleUpdateAccount(){
            if (!accountForm.isDirty || (accountForm.password_confirmation != '' && accountForm.password == '')) {
                return false
            }

            isBusy.value = true

            var updatedCredentials = false

            await accountForm.post(route('auth.change.credentials')).then(response => {
                if (response.status == 200) {
                    updatedCredentials = true
                }
            }).catch(error => {
                console.log(error.response)
            })

            if (updatedCredentials) {
                accountEdit.value = false

                setTimeout(() => {
                    accountForm.reset()
                }, 2000);
            }

            isBusy.value = false
        }

        async function handleNext(){
            isBusy.value = true

            storeForm.intake = store.state

            await storeForm.post(route('intake.validate.store')).then(response => {
                if (response.status == 200) {
                    isBusy.value = false
                    success.value = true
                }
            }).catch(error => {
                console.log(error.response)
                isBusy.value = false
                window.scrollTo(0, 0)
            })
        }

        async function handleDone(){
            isBusy.value = true

            // store notification first
            store.commit('UPDATE_FORM_DATA', {
                form: 'notificationForm',
                data: form.data()
            });

            // create hubspot
            await axios.post(route('api.hubspot.create-contact'), {
                firstname: onboardingData.value.primaryData.firstName,
                lastname: onboardingData.value.primaryData.lastName,
                email: onboardingData.value.primaryData.email,
                phone: summaryData.value.phoneNumber,
            }).then(response => {
                if (response.status == 200) {
                    console.log(response.data)
                }
            }).catch(error => {
                console.log(error.response)
            })

            storeForm.intake = store.state

            await storeForm.post(route('intake.store')).then(response => {
                if (response.status == 200) {
                    emit('complete', true)
                }
            }).catch(error => {
                console.log(error.response)
                isBusy.value = false
                window.scrollTo(0, 0)
            })
        }

        function handlePrint(){
            window.print()
        }

        return {
            isBusy,
            success,
            isDropdown,
            showAccount,
            accountDropdown,
            accountEdit,
            form,
            accountForm,
            storeForm,
            onboardingData,
            summaryData,
            handleEdit,
            handleBack,
            handleNext,
            handleDone,
            handleUpdateAccount,
            handlePrint
        }
    },
    computed: {
        currentDate(){
            return moment().format('MMMM Do, YYYY, h:mma zz')
        },
        avatar(){
            const firstName = _.get(this.$page.props, 'auth.user.first_name')
            const lastName = _.get(this.$page.props, 'auth.user.last_name')
            const fullName = firstName + ' ' + lastName

            return `https://ui-avatars.com/api/?name=${encodeURI(fullName)}&color=FFFFFF&background=57808B`
        }
    }
}
</script>

<style>
</style>
